import { useTranslation } from "react-i18next";
import { NeuInput, NeuSelect } from "../../components/neu/Neu";

const TYPES = ["full", "parts_only", "service_only", "limited"];

// كفالة اختيارية: مربع تفعيل يُظهر مدة/نوع/تفاصيل التغطية عند التحديد.
export const WarrantySection = ({ head, onChange }) => {
  const { t } = useTranslation();
  const enabled = !!head.warranty_enabled;
  const set = (key) => (e) => onChange({ ...head, [key]: e.target.value });
  const toggle = (e) => onChange({
    ...head,
    warranty_enabled: e.target.checked,
    ...(e.target.checked
      ? { warranty_months: head.warranty_months || "12", warranty_type: head.warranty_type || "full" }
      : { warranty_months: "", warranty_type: "", warranty_notes: "", warranty_provider: "" }),
  });
  return (
    <div className="grid gap-3">
      <label className="flex cursor-pointer items-center gap-2 text-xs font-bold"
             data-testid="warranty-enable-label">
        <input type="checkbox" data-testid="warranty-enable" checked={enabled} onChange={toggle}
               className="h-4 w-4 rounded border-border" />
        <span>{t("purchases.warranty.enable")}</span>
      </label>
      {enabled ? (
        <div className="grid gap-3">
          <div className="grid gap-3 sm:grid-cols-2">
            <label className="grid gap-1">
              <span className="text-[11px] font-bold text-muted-foreground">
                {t("purchases.warranty.months")}
              </span>
              <NeuInput data-testid="warranty-months" dir="ltr" type="number" min="0"
                        value={head.warranty_months || ""} onChange={set("warranty_months")}
                        placeholder="12" />
            </label>
            <label className="grid gap-1">
              <span className="text-[11px] font-bold text-muted-foreground">
                {t("purchases.warranty.type")}
              </span>
              <NeuSelect data-testid="warranty-type" value={head.warranty_type || "full"}
                         onChange={set("warranty_type")}>
                {TYPES.map((k) => (
                  <option key={k} value={k}>{t(`purchases.warranty.types.${k}`)}</option>
                ))}
              </NeuSelect>
            </label>
          </div>
          <label className="grid gap-1">
            <span className="text-[11px] font-bold text-muted-foreground">
              {t("purchases.warranty.coverage")}
            </span>
            <textarea data-testid="warranty-notes" value={head.warranty_notes || ""}
                      onChange={set("warranty_notes")}
                      placeholder={t("purchases.warranty.coveragePh")}
                      className="min-h-[80px] rounded-2xl bg-background px-4 py-3 text-sm shadow-neu-in outline-none focus:ring-2 focus:ring-ring" />
          </label>
        </div>
      ) : null}
    </div>
  );
};
